import { eq } from "../utils";
import { text } from "../utils/i18n";
import { createTemporaryId } from "../utils/model";

export class UnroutedContactFlowStage {
  readonly id = createTemporaryId();
  /**
   * Identifies the stage even when the id changes, such as when the stage has been created.
   */
  readonly key = createTemporaryId();
  readonly tagIds: string[] = [];
  /**
   * Set and used by UI/UX only.
   */
  readonly isGroupable: boolean = true;
  
  constructor(deriveFrom?: Partial<UnroutedContactFlowStage>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }

  isValid() {
    return this.tagIds.length > 0;
  }
}

export const defaultUnroutedContactFlow = text`Nytt flöde`;

export class UnroutedContactFlow {
  readonly id = createTemporaryId();
  readonly createdAt = new Date();
  readonly name: string = defaultUnroutedContactFlow;
  readonly stages: UnroutedContactFlowStage[] = [];

  constructor(deriveFrom?: Partial<UnroutedContactFlow>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.createdAt = new Date(this.createdAt);

    this.stages = this.stages.map(stage => new UnroutedContactFlowStage(stage));
  }

  isValid() {
    return this.stages.length > 0 && this.stages.every(stage => stage.isValid());
  }

  isSimilarTo(other: UnroutedContactFlow): boolean {
    const comparableStages = this.stages.map(stage => getComparableStage(stage));
    const otherComparableStages = other.stages.map(stage => getComparableStage(stage));

    return eq(comparableStages, otherComparableStages);
  }
}

type ComparableStage = Pick<UnroutedContactFlowStage, 'tagIds'>;

function getComparableStage(stage: UnroutedContactFlowStage): ComparableStage {
  return { tagIds: stage.tagIds };
}